<i18n>
{
  "en": {
    "dictionaries": {
      "id": "ID",
      "code": "Code",
      "name": "Name",
      "title": "Dictionaries"
    }
  },
  "ru": {
    "dictionaries": {
      "id": "ID",
      "code": "Код",
      "name": "Наименование",
      "title": "Справочники"
    }
  }
}
</i18n>

<template>
  <div class="content-block">
    <dx-data-grid
      v-if="dataSourceConfig"
      class="data-grid dx-card"
      :data-source="dataSourceConfig.pageRows"
      :remote-operations="remoteOperations"
      :syncLookupFilterValues="false"
      :height="gridHeight"
      @content-ready="onContentReady"
      @row-click="onRowClick"
      @context-menu-preparing="addMenuItems"
      @editor-preparing="onEditorPreparing"
      @initialized=initializedGrid
      ref="dataGrid"
    >
      <dx-paging :enabled="true" />
      <dx-pager
        :visible="true"
        :allowed-page-sizes="pageSize"
        display-mode="full"
        :show-page-size-selector="true"
        :show-info="true"
        :show-navigation-buttons="false"
      />

      <dx-filter-row :visible="true" />
      <dx-header-filter :visible="true" />
      <dx-sorting mode="multiple" />
      <dx-state-storing
        :enabled="true"
        type="custom"
        :customLoad="stateLoad"
        :customSave="stateSave"
      />
      <dx-filter-panel :visible="true" />

      <dx-column
        data-field="code"
        :caption="$t('dictionaries.code')"
        :width="160"
        :allow-header-filtering="false"
      />
      <dx-column
        data-field="name"
        :caption="$t('dictionaries.name')"
        :allow-header-filtering="false"
      />
    </dx-data-grid>

    <CustomColumnChooser
      :visible="visible"
      :columns="columns"
      :onApply="onApply"
      :onHiding="onHiding"
    />
  </div>
</template>

<script>
import baseView from "../base";
import appInfo from "../../app-info";

import DxDataGrid, {
  DxColumn, DxFilterRow, DxHeaderFilter, DxPaging, DxStateStoring, DxFilterPanel, DxPager,
  DxSorting
} from "devextreme-vue/data-grid";

import CustomColumnChooser from "@/components/column-chooser/CustomColumnChooser.vue";

import { findDictionaries } from "@/services/api";

import { DataDrid } from "@/mixins/dataDridMixin";

import {
  PAGE_HEADER_HEIGHT,
  PAGE_PADDING,
  PAGE_FOOTER_HEIGHT,
  GRID_HEADER_HEIGHT,
  GRID_FILTER_ROW_HEIGHT,
  GRID_FILTER_PANEL_HEIGHT,
  GRID_PAGER_HEIGHT
} from '@/shared/consts/layout';

export default {
  extends: baseView,
  mixins: [DataDrid],
  components: {
    DxDataGrid, DxColumn, DxFilterRow, DxHeaderFilter, DxPaging, DxStateStoring,
    DxFilterPanel, CustomColumnChooser, DxPager, DxSorting
  },
  data() {
    return {
      remoteOperations: { groupPaging: true },
      dataSourceConfig: null,
      develop: null,
    };
  },
  computed: {
    sumGap() {
      return PAGE_HEADER_HEIGHT + PAGE_PADDING + PAGE_FOOTER_HEIGHT;
    },
    gridHeight() {
      const appHeightSize = this.$store.getters.appContainerSize.height;
      return (appHeightSize || 800) - this.sumGap;
    },
    gridBodyHeight() {
      return this.gridHeight - GRID_HEADER_HEIGHT - GRID_FILTER_ROW_HEIGHT - GRID_FILTER_PANEL_HEIGHT - GRID_PAGER_HEIGHT;
    },
  },
  methods: {
    onEditorPreparing(e) {
      this.applyFilterRowTimeout(e);
    },
    onContentReady(e) {
      this.addFitToPageHeightButton(e);
    },
    onRowClick(e) {
      if (window.getSelection().focusOffset !== window.getSelection().anchorOffset)
        return;

      if (e.event.metaKey || e.event.ctrlKey) {
        const routeData = this.$router.resolve({
          name: "dictionary",
          params: { id: e.data.id }
        });
        window.open(routeData.href, "_blank");
      } else {
        this.$router.push({
          name: "dictionary",
          params: { id: e.data.id }
        });
      }
    },
    onCreate() {
      this.$router.push({ name: "dictionary" });
    },
  },
  async created() {
    this.gridStateKey = 'gridDictionaries';

    let filter = {
      page: '9,1',
    };

    this.dataSourceConfig = await findDictionaries(filter);
    this.dataSourceConfig.pageRows = this.dataSourceConfig.pageRows.filter(item => item.code !== 'LOCATION');
    
    document.title = `${appInfo.title} - ${this.$t('dictionaries.title')}`;
    this.$store.commit("setBreadcrumb", [{
      link: "/dictionaries",
      title: this.$t('dictionaries.title')
    }]);
  },
  beforeDestroy() {
    const state = this.dataGrid.state();
    this.stateSave(state);
  },
};
</script>

<style lang="scss" scoped>
.data-grid {
  margin-top: 0;
}
</style>
